import script from "./TextDisplayer.vue?vue&type=script&setup=true&lang=js"
export * from "./TextDisplayer.vue?vue&type=script&setup=true&lang=js"

import "./TextDisplayer.vue?vue&type=style&index=0&id=705e462c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705e462c"]])

export default __exports__